// extracted by mini-css-extract-plugin
module.exports = {"icons":"CloudPaymentsBlockIcons_icons_2EnOW"};